import { StringType } from "./strings";

const STRING_CH: StringType = {
  translation: {
    general: {
      loading: "Am Lade...",
    },
    burgerMenu: {
      dutyPlan: "Ämtliplan",
      dashboard: "Däshbord",
      lights: "Liechter",
      jokeOfTheDay: "Witz vom Tag",
      settings: "Iistellige",
      deliveryDriver: "Essensfahrer",
      wifi: "WLAN",
      camera: "Chamera",
      images: "Bilder",
      scavengerhunt: "Schnitzeljagd",
    },
    dutyCard: {
      tasks: "Uufgobe",
      tasksInDetail: "Detailierte Uufgobe",
      everyWeek: "Jedi Wuche",
      everyXWeeks_one: "All {{count}} Wuche",
      everyXWeeks_other: "All {{count}} Wuche",
      day_one: "{{count}} Tag",
      day_other: "{{count}} Täg",
    },
    trashCalendar: {
      title: "Abfallchalendar",
    },
    duties: {
      bathroom: {
        name: "Bad",
        quote:
          "Wer öpperem i d Schüssle schiisst, muess mit de Konsequänze rechne!",
        generalTasks: {
          bathroom: "Bad",
          trash: "Chüder",
        },
        detailedTasks: {
          cleanToilet: "WC putze",
          cleanSink: "Lavabo putze",
          cleanShower: "Duschi putze",
          cleanFurniture: "Möbel putze",
          disposeTrash: "Chüder entsorge",
          disposeCompost: "Kompost entsorge",
        },
      },
      floor: {
        name: "Böde",
        quote: "Dr Bode treit eus für immer und ewig!",
        generalTasks: {
          livingRoom: "Stube",
          floor: "Bode",
          glasAndCans: "Glas & Dose",
        },
        detailedTasks: {
          cleanSofa: "Polstergruppe putze",
          lamps: "Lampä",
          vacuumClean: "Staubsuuge",
          wipeFloor: "Füecht ufneh",
          disposeGlasAndCans: "Glas & Dose entsorge",
          waterPlants: "Pflanze güüsse",
        },
      },
      kitchen: {
        name: "Chuchi",
        quote: "Ohni es El Tony gohts nöd!",
        generalTasks: {
          kitchen: "Chuchi",
          petAndPlasticBottles: "PET- und Plastikfläsche",
          cardboardAndPaper: "Karton und Papiir",
        },
        detailedTasks: {
          cleanStoveTableAndSink: "Herd, Tisch und Lavabo putze",
          cleanSurfaces: "Oberflächi putze",
          cleanTrashCabinet: "Abfallschrank putze",
          cleanSteamExhaust: "Dampfabzug putze",
          disposeCardboardAndPaper: "Karton und Papiir entsorge",
          disposePetAndPlasticBottles: "PET- und Plastikfläsche entsorge",
        },
      },
    },
    weatherCodes: {
      sunny: "Sunnig",
      clear: "Chlar",
      mainlySunny: "Meistens Sunnig",
      mainlyClear: "Meistens Chlar",
      partlyCloudy: "Teilwiis Bewölkt",
      cloudy: "Bewölkt",
      foggy: "Nebel",
      rimeFog: "Nebel",
      lightDrizzle: "Liechts Niesle",
      drizzle: "Niesle",
      heavyDrizzle: "Starks Niesle",
      lightFreezingDrizzle: "Liechts iischalts Niesle",
      freezingDrizzle: "Iischalts Niesle",
      lightRain: "Liechte Räge",
      rain: "Räge",
      heavyRain: "Starche Räge",
      lightFreezingRain: "Liechte iischalte Räge",
      freezingRain: "Iischalte Räge",
      lightSnow: "Liechte Schnee",
      snow: "Schnee",
      heavySnow: "Starche Schnee",
      snowGrains: "Schneechörner",
      lightShowers: "Liechti Schauer",
      showers: "Schauer",
      heavyShowers: "Starchi Schauer",
      lightSnowShowers: "Liechti Schneeschauer",
      snowShowers: "Schneeschauer",
      thunderstorm: "Gwitter",
      lightThunderstormsWithHail: "Liechts Gwitter mit Hagel",
      thunderstormWithHail: "Gwitter mit Hagel",
    },
    deliveryDrivers: {
      orderedOn: "Bstellt am",
      order: "Bstellig:",
    },
    camera: {
      done: "Fertig!",
      imagePreviewInfoText: "Ds Bild chasch uf de Bilder-Seite ahluege",
    },
    settings: {
      language: "Sproch",
      theme: "Thema",
      reload: "Website neu lade",
    },
  },
};

export default STRING_CH;
